export const RESTRICTED_DETAIL_SENTENCE =
  'This data is restricted because you are either outside the US or do not have access.'
